module.exports = __webpack_public_path__ + "img/tokyo.6222365c.png";